import { render, staticRenderFns } from "./CalendarEventElement.vue?vue&type=template&id=075a52a1&scoped=true&"
import script from "./CalendarEventElement.vue?vue&type=script&lang=js&"
export * from "./CalendarEventElement.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEventElement.vue?vue&type=style&index=0&id=075a52a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075a52a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VDivider,
  VMenu,
  VSpacer,
  VToolbar,
  VToolbarTitle,
})
